var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"es-tooltip"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('div',{staticClass:"es-tooltip-arrow",attrs:{"data-popper-arrow":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }